import React, { createContext, useContext } from 'react';
function createSafeContext(errorMessage) {
    var Context = createContext(null);
    var useSafeContext = function() {
        var ctx = useContext(Context);
        if (ctx === null) {
            throw new Error(errorMessage);
        }
        return ctx;
    };
    var Provider = function(param) {
        var children = param.children, value = param.value;
        return /* @__PURE__ */ React.createElement(Context.Provider, {
            value: value
        }, children);
    };
    return [
        Provider,
        useSafeContext
    ];
}
export { createSafeContext }; //# sourceMappingURL=create-safe-context.js.map
